import dayjs from 'dayjs';
import 'dayjs/locale/tr';
import { ExpertGroupMemberResponseLiveServiceTypeEnum } from '@dopingtech/live_expert_bff_api_ts';
import { ClassroomExpertMember, ClassroomGroup, SelectItem } from '../../boutique-classroom.types';
import { BoutiqueStudent } from '../../students/boutique-students.types';
import { MINUTES_IN_HOUR } from '../../boutique-classroom.constants';
import { PLANNED_LESSON_BLOCKER, PLANNED_LESSON_TIME_LENGTH } from './planned-lesson-modal.constants';

const LOCALE = 'tr';

export function getInitials(fullName: string): string {
	return fullName
		.trim()
		.split(/\s+/)
		.slice(0, 2)
		.map(part => part.charAt(0).toLocaleUpperCase('tr-TR'))
		.join('');
}

function isPlannedLectureExpert(expert: ClassroomExpertMember): boolean {
	return expert.liveServiceType === ExpertGroupMemberResponseLiveServiceTypeEnum.PlannedLecture && expert.branchId !== undefined;
}

export function getBoardExperts(student: BoutiqueStudent, groups: ClassroomGroup[]): ClassroomExpertMember[] {
	return groups.find(group => group.id === student.groupId)?.experts.filter(isPlannedLectureExpert) ?? [];
}

export function getPlannedLessonBlocker(student: BoutiqueStudent, groups: ClassroomGroup[]): string | null {
	const group = student.groupId === null ? undefined : groups.find(item => item.id === student.groupId);
	if (!group) return PLANNED_LESSON_BLOCKER.NOT_IN_GROUP;
	if (!group.experts.length) return PLANNED_LESSON_BLOCKER.NO_ACADEMIC_BOARD;
	if (!group.experts.some(isPlannedLectureExpert)) return PLANNED_LESSON_BLOCKER.NO_BOARD_EXPERT;
	return null;
}

export function getBranchOptions(experts: ClassroomExpertMember[]): SelectItem[] {
	const byId = new Map<number, SelectItem>();
	experts.forEach(expert => byId.set(expert.branchId as number, { id: expert.branchId as number, name: expert.branchName ?? '' }));
	return Array.from(byId.values()).sort((a, b) => a.name.localeCompare(b.name, LOCALE));
}

export function getExpertOptions(experts: ClassroomExpertMember[], branchId: number | null): SelectItem[] {
	if (branchId === null) return [];
	const byId = new Map<number, SelectItem>();
	experts.filter(expert => expert.branchId === branchId).forEach(expert => byId.set(expert.id, { id: expert.id, name: expert.fullName }));
	return Array.from(byId.values());
}

export function toTimeLabel(value: unknown): string {
	return String(value ?? '').slice(0, PLANNED_LESSON_TIME_LENGTH);
}

function toMinutes(time: string): number {
	const [hours, minutes] = time.split(':').map(Number);
	return hours * MINUTES_IN_HOUR + minutes;
}

export function getDurationMinutes(startTime: string, endTime: string): number {
	return toMinutes(endTime) - toMinutes(startTime);
}

export function formatDate(date: string, format: string): string {
	return dayjs(date).locale(LOCALE).format(format);
}

export function toSlotKey(date: string, slotId: number): string {
	return `${date}|${slotId}`;
}
